import { motion } from "framer-motion";

const BLOSSOMS = [
  [40, 182, "#f9a8d4"], [70, 178, "#fde68a"], [104, 176, "#c4b5fd"], [228, 182, "#f472b6"], [262, 178, "#a7f3d0"],
  [300, 174, "#fbcfe8"], [338, 172, "#fde68a"], [366, 170, "#93c5fd"], [16, 186, "#fff1f7"], [386, 168, "#f9a8d4"],
];

function Bird({ flip, offset }) {
  return (
    <motion.g animate={{ x: offset }} transition={{ duration: 1.2, ease: "easeOut" }}>
      <g transform={flip ? "translate(322 92) scale(-1 1)" : "translate(78 92)"}>
        <motion.g animate={{ scaleY: [1, 1.03, 1] }} transition={{ duration: 3.2, repeat: Infinity }} style={{ originX: "55px", originY: "80px" }}>
          <path d="M26 62 L0 80 L9 85 L32 71 Z" fill="#07050b" />
          <ellipse cx="55" cy="58" rx="33" ry="25" transform="rotate(-12 55 58)" fill="#07050b" />
          <circle cx="83" cy="35" r="16" fill="#07050b" />
          <path d="M97 31 L111 36 L97 40 Z" fill="#07050b" />
          <path d="M44 52 Q60 40 78 58 Q60 64 44 52 Z" fill="#140d1d" />
        </motion.g>
        <path d="M52 80 L50 93 M63 80 L63 93" stroke="#07050b" strokeWidth="2.5" />
      </g>
    </motion.g>
  );
}

export function TwoBirds({ warmth, originRef }) {
  const gap = (1 - warmth) * 16;
  return (
    <div className="relative w-[min(86vw,560px)]">
      <svg viewBox="0 0 400 210" className="w-full overflow-visible" data-testid="love-birds">
        <path d="M-60 196 Q90 176 200 186 T470 166" stroke="#07050b" strokeWidth="7" fill="none" strokeLinecap="round" />
        <Bird offset={-gap} />
        <Bird flip offset={gap} />
        {BLOSSOMS.map(([x, y, c], i) => (
          <circle
            key={i}
            cx={x}
            cy={y}
            r={3 + (i % 3)}
            fill={c}
            className="animate-twinkle"
            style={{ opacity: Math.min(1, warmth * 1.6 - i * 0.07), animationDelay: `${i * 0.31}s`, transformOrigin: `${x}px ${y}px` }}
          />
        ))}
      </svg>
      <div ref={originRef} className="pointer-events-none absolute left-1/2 top-[18%] h-2 w-2 -translate-x-1/2" />
    </div>
  );
}

export function Moon({ warmth }) {
  const size = "min(78vw, 78vh)";
  return (
    <>
      <div
        className="animate-spin-slow pointer-events-none absolute left-1/2 top-[44%] rounded-full"
        style={{
          width: `calc(${size} * 1.5)`,
          height: `calc(${size} * 1.5)`,
          opacity: 0.25 + warmth * 0.6,
          WebkitMaskImage: "radial-gradient(circle, #000 20%, transparent 70%)",
          maskImage: "radial-gradient(circle, #000 20%, transparent 70%)",
          background:
            "conic-gradient(from 0deg, transparent, rgba(244,114,182,.45), transparent 22%, rgba(167,139,250,.5), transparent 48%, rgba(251,207,232,.4), transparent 72%, rgba(126,87,194,.45), transparent)",
        }}
      />
      <div
        data-testid="love-moon"
        className="pointer-events-none absolute left-1/2 top-[44%] -translate-x-1/2 -translate-y-1/2 rounded-full"
        style={{
          width: `calc(${size} * 0.62)`,
          height: `calc(${size} * 0.62)`,
          background: "radial-gradient(circle at 45% 40%, #ffffff 0%, #fbf7ff 45%, #e9dcf5 75%, #cdb6e6 100%)",
          opacity: 0.55 + warmth * 0.45,
          boxShadow: `0 0 ${60 + warmth * 140}px ${10 + warmth * 50}px rgba(251,240,255,${0.15 + warmth * 0.35})`,
        }}
      />
    </>
  );
}
